import styled from 'styled-components';

export const ContactBoxContainer = styled.div`
  padding: 2.8rem 2.6rem;
  background-color: rgba(237, 66, 36, 0.1);
  border-radius: 5px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;

  > div {
    p:first-child {
      font-weight: 700;
      font-size: 1.4rem;
      line-height: 2.1rem;
      color: #000;

      margin-bottom: 0.6rem;
    }

    p:last-child {
      font-weight: 400;
      font-size: 1.1rem;
      line-height: 1.65rem;
      color: #2a2a2a;
    }
  }

  > a {
    padding: 1rem 1.6rem;
    background-color: ${({ theme }) => theme.color.primary};
    border-radius: 5px;

    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #fff;

    &:hover {
      color: #fff;
      text-decoration: none;
    }
  }

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
